import { createRouter as createTanstackRouter } from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen';

let routerSingleton: ReturnType<typeof createTanstackRouter> | null = null;

export function createRouter() {
  const queryClient = new QueryClient();

  return createTanstackRouter({
    routeTree,
    basepath: '/',
    context: {
      queryClient,
    },
    scrollRestoration: true,
  });
}

export function getRouter() {
  // SSR: always create a fresh router so request state (redirects, matches,
  // current location) never leaks between concurrent or sequential server
  // requests. Reusing one instance across requests in a worker isolate caused
  // intermittent cross-request redirects (e.g. /features 307-ing to /blog).
  // Client: use a singleton so a single router instance handles all navigations.
  if (typeof window === 'undefined') {
    return createRouter();
  }
  if (!routerSingleton) {
    routerSingleton = createRouter();
  }
  return routerSingleton;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
